module.exports = __webpack_public_path__ + "media/img/pages/companies/graub-959f3f1bf9a46cd3c761d27f40c3ff88.png";